import { PLACES } from './seasonalFeatured';

const RADIUS = '5mi';
export const NEIGHBOURHOOD = {
    [PLACES.ATLANTA]: [
        {
            name: 'Downtown Atlanta',
            point_radius: {
                radius: RADIUS,
                latitude: 33.7538,
                longitude: -84.3915,
            },
        },
        {
            name: 'Westside Atlanta',
            point_radius: {
                radius: RADIUS,
                latitude: 33.7865,
                longitude: -84.4454,
            },
        },
        {
            name: 'Summerhill',
            point_radius: {
                radius: RADIUS,
                latitude: 33.7457,
                longitude: -84.3755,
            },
        },
    ],
    [PLACES.CHICAGO]: [
        {
            name: 'Lincoln Park',
            point_radius: {
                radius: RADIUS,
                latitude: 41.9227,
                longitude: -87.6494,
            },
        },
        {
            name: 'Little Italy',
            point_radius: {
                radius: RADIUS,
                latitude: 41.8781,
                longitude: -87.6515,
            },
        },
        {
            name: 'River North',
            point_radius: {
                radius: RADIUS,
                latitude: 41.8876,
                longitude: -87.6366,
            },
        },
    ],
    [PLACES.WASHINGTON_DC]: [
        {
            name: 'Mount Vernon Square',
            point_radius: {
                radius: RADIUS,
                latitude: 38.9111,
                longitude: -77.0207,
            },
        },
        {
            name: 'Dupont Circle',
            point_radius: {
                radius: RADIUS,
                latitude: 38.9067,
                longitude: -77.0425,
            },
        },
        {
            name: 'Near Northeast',
            point_radius: {
                radius: RADIUS,
                latitude: 38.905,
                longitude: -77.0104,
            },
        },
    ],
    [PLACES.LONDON]: [
        {
            name: 'Wembley',
            point_radius: {
                radius: RADIUS,
                latitude: 51.5569,
                longitude: -0.2817,
            },
        },
        {
            name: 'Greenwhich',
            point_radius: {
                radius: RADIUS,
                latitude: 51.508,
                longitude: 0.0275,
            },
        },
        {
            name: 'Whitechapel',
            point_radius: {
                radius: RADIUS,
                latitude: 51.5168,
                longitude: -0.0651,
            },
        },
    ],
    [PLACES.LOS_ANGELES]: [
        {
            name: 'Hollywood',
            point_radius: {
                radius: RADIUS,
                latitude: 34.1026,
                longitude: -118.3257,
            },
        },
        {
            name: 'Downtown Los Angeles',
            point_radius: {
                radius: RADIUS,
                latitude: 34.0417,
                longitude: -118.2322,
            },
        },
        {
            name: 'South park',
            point_radius: {
                radius: RADIUS,
                latitude: 34.039,
                longitude: -118.2673,
            },
        },
    ],
    [PLACES.MELBOURNE_AU]: [
        {
            name: 'Melbourne CBD',
            point_radius: {
                radius: RADIUS,
                latitude: -37.8142,
                longitude: 144.9632,
            },
        },
        {
            name: 'Southbank',
            point_radius: {
                radius: RADIUS,
                latitude: -37.8245,
                longitude: 144.9649,
            },
        },
        {
            name: 'Carlton',
            point_radius: {
                radius: RADIUS,
                latitude: -37.7841,
                longitude: 144.9728,
            },
        },
    ],
    [PLACES.MIAMI]: [
        {
            name: 'Wynwood',
            point_radius: {
                radius: RADIUS,
                latitude: 25.8131,
                longitude: -80.1998,
            },
        },
        {
            name: 'Miami Beach',
            point_radius: {
                radius: RADIUS,
                latitude: 25.7907,
                longitude: -80.13,
            },
        },
        {
            name: 'Spring Garden',
            point_radius: {
                radius: RADIUS,
                latitude: 25.791,
                longitude: -80.2026,
            },
        },
    ],
    [PLACES.NEW_YORK]: [
        {
            name: 'Lower East Side',
            point_radius: {
                radius: RADIUS,
                latitude: 40.7151,
                longitude: -73.984,
            },
        },
        {
            name: 'Midtown West',
            point_radius: {
                radius: RADIUS,
                latitude: 40.759,
                longitude: -73.9845,
            },
        },
        {
            name: 'Chelsea',
            point_radius: {
                radius: RADIUS,
                latitude: 40.7506,
                longitude: -73.9971,
            },
        },
    ],
    [PLACES.SAN_FRANCISCO]: [
        {
            name: 'South Of Market',
            point_radius: {
                radius: RADIUS,
                latitude: 37.7725,
                longitude: -122.4102,
            },
        },
        {
            name: 'Lakeshore',
            point_radius: {
                radius: RADIUS,
                latitude: 37.7227,
                longitude: -122.4812,
            },
        },
        {
            name: 'Downtown Oakland',
            point_radius: {
                radius: RADIUS,
                latitude: 37.8049,
                longitude: -122.2711,
            },
        },
    ],
    [PLACES.TORONTO_CA]: [
        {
            name: 'Entertainment District',
            point_radius: {
                radius: RADIUS,
                latitude: 43.6404,
                longitude: -79.3912,
            },
        },
        {
            name: 'Mississauga',
            point_radius: {
                radius: RADIUS,
                latitude: 43.6879,
                longitude: -79.6114,
            },
        },
        {
            name: 'Kensington Market',
            point_radius: {
                radius: RADIUS,
                latitude: 43.6555,
                longitude: -79.4025,
            },
        },
    ],
    [PLACES.AUSTIN]: [
        {
            name: 'Downtown Austin',
            point_radius: {
                radius: RADIUS,
                latitude: 30.2672,
                longitude: -97.7431,
            },
        },
        {
            name: 'East Austin',
            point_radius: {
                radius: RADIUS,
                latitude: 30.2638,
                longitude: -97.7156,
            },
        },
        {
            name: 'South Austin',
            point_radius: {
                radius: RADIUS,
                latitude: 30.2414,
                longitude: -97.7688,
            },
        },
    ],
    [PLACES.BALTIMORE_MD]: [
        {
            name: 'Downtown Baltimore',
            point_radius: {
                radius: RADIUS,
                latitude: 39.2937,
                longitude: -76.6145,
            },
        },
        {
            name: 'Inner Harbor',
            point_radius: {
                radius: RADIUS,
                latitude: 39.2866,
                longitude: -76.6077,
            },
        },
        {
            name: 'Columbia',
            point_radius: {
                radius: RADIUS,
                latitude: 39.211,
                longitude: -76.8637,
            },
        },
    ],
    [PLACES.BOSTON_MA]: [
        {
            name: 'Brookline',
            point_radius: {
                radius: RADIUS,
                latitude: 42.3471,
                longitude: -71.1021,
            },
        },
        {
            name: 'Back Bay',
            point_radius: {
                radius: RADIUS,
                latitude: 42.3486,
                longitude: -71.076,
            },
        },
        {
            name: 'South Boston Waterfront',
            point_radius: {
                radius: RADIUS,
                latitude: 42.3525,
                longitude: -71.0485,
            },
        },
    ],
    [PLACES.CHARLOTTE_NC]: [
        {
            name: 'Uptown Charlotte',
            point_radius: {
                radius: RADIUS,
                latitude: 35.2271,
                longitude: -80.8431,
            },
        },
        {
            name: 'Druid Hills North',
            point_radius: {
                radius: RADIUS,
                latitude: 35.2561,
                longitude: -80.8171,
            },
        },
        {
            name: 'Westerly Hills',
            point_radius: {
                radius: RADIUS,
                latitude: 35.2406,
                longitude: -80.8682,
            },
        },
    ],
    [PLACES.DALLAS]: [
        {
            name: 'Downtown Dallas',
            point_radius: {
                radius: RADIUS,
                latitude: 32.7875,
                longitude: -96.7994,
            },
        },
        {
            name: 'South Dallas',
            point_radius: {
                radius: RADIUS,
                latitude: 32.758,
                longitude: -96.7589,
            },
        },
        {
            name: 'Deep Ellum',
            point_radius: {
                radius: RADIUS,
                latitude: 32.7885,
                longitude: -96.7768,
            },
        },
    ],
    [PLACES.DENVER_CO]: [
        {
            name: 'Downtown Denver',
            point_radius: {
                radius: RADIUS,
                latitude: 39.7526,
                longitude: -104.9962,
            },
        },
        {
            name: 'North Denver',
            point_radius: {
                radius: RADIUS,
                latitude: 39.7598,
                longitude: -104.9725,
            },
        },
        {
            name: 'Colfax',
            point_radius: {
                radius: RADIUS,
                latitude: 39.7325,
                longitude: -105.0128,
            },
        },
    ],
    [PLACES.DETROIT_MI]: [
        {
            name: 'Downtown Detroit',
            point_radius: {
                radius: RADIUS,
                latitude: 42.3314,
                longitude: -83.0458,
            },
        },
        {
            name: 'Rivertown - Warehouse District',
            point_radius: {
                radius: RADIUS,
                latitude: 42.3463,
                longitude: -83.0386,
            },
        },
        {
            name: 'New Center',
            point_radius: {
                radius: RADIUS,
                latitude: 42.3744,
                longitude: -83.0778,
            },
        },
    ],
    [PLACES.HOUSTON]: [
        {
            name: 'Downtown Houston',
            point_radius: {
                radius: RADIUS,
                latitude: 29.7572,
                longitude: -95.3584,
            },
        },
        {
            name: 'East Downtown',
            point_radius: {
                radius: RADIUS,
                latitude: 29.7499,
                longitude: -95.3404,
            },
        },
        {
            name: 'Greater Uptown',
            point_radius: {
                radius: RADIUS,
                latitude: 29.7449,
                longitude: -95.4881,
            },
        },
    ],
    [PLACES.LAS_VEGAS_NV]: [
        {
            name: 'Winchester',
            point_radius: {
                radius: RADIUS,
                latitude: 36.1299,
                longitude: -115.1398,
            },
        },
        {
            name: 'Spring Valley',
            point_radius: {
                radius: RADIUS,
                latitude: 36.1146,
                longitude: -115.2126,
            },
        },
        {
            name: 'Paradise',
            point_radius: {
                radius: RADIUS,
                latitude: 36.0877,
                longitude: -115.152,
            },
        },
    ],
    [PLACES.MINNEAPOLIS_MN]: [
        {
            name: 'Warehouse District',
            point_radius: {
                radius: RADIUS,
                latitude: 44.9843,
                longitude: -93.2655,
            },
        },
        {
            name: 'Nokomis',
            point_radius: {
                radius: RADIUS,
                latitude: 44.9059,
                longitude: -93.2323,
            },
        },
        {
            name: 'Downtown West',
            point_radius: {
                radius: RADIUS,
                latitude: 44.972,
                longitude: -93.2848,
            },
        },
    ],
    [PLACES.ORLANDO]: [
        {
            name: 'Downtown Orlando',
            point_radius: {
                radius: RADIUS,
                latitude: 28.5413,
                longitude: -81.379,
            },
        },
        {
            name: 'Dr. Phillips',
            point_radius: {
                radius: RADIUS,
                latitude: 28.4525,
                longitude: -81.477,
            },
        },
        {
            name: 'Colonialtown North',
            point_radius: {
                radius: RADIUS,
                latitude: 28.5592,
                longitude: -81.3649,
            },
        },
    ],
    [PLACES.PHILADELPHIA_PA]: [
        {
            name: 'University City',
            point_radius: {
                radius: RADIUS,
                latitude: 39.9607,
                longitude: -75.199,
            },
        },
        {
            name: 'South Philadelphia',
            point_radius: {
                radius: RADIUS,
                latitude: 39.9471,
                longitude: -75.1624,
            },
        },
        {
            name: 'Old city philadelphia',
            point_radius: {
                radius: RADIUS,
                latitude: 39.949,
                longitude: -75.145,
            },
        },
    ],
    [PLACES.PHOENIX_AZ]: [
        {
            name: 'Downtown Phoenix',
            point_radius: {
                radius: RADIUS,
                latitude: 33.4516,
                longitude: -112.0716,
            },
        },
        {
            name: 'Tempe',
            point_radius: {
                radius: RADIUS,
                latitude: 33.4326,
                longitude: -111.9396,
            },
        },
        {
            name: 'Scottsdale',
            point_radius: {
                radius: RADIUS,
                latitude: 33.4936,
                longitude: -111.9273,
            },
        },
    ],
    [PLACES.SAN_DIEGO_CA]: [
        {
            name: 'Downtown San Diego',
            point_radius: {
                radius: RADIUS,
                latitude: 32.7187,
                longitude: -117.1625,
            },
        },
        {
            name: 'Mission Valley',
            point_radius: {
                radius: RADIUS,
                latitude: 32.7724,
                longitude: -117.1405,
            },
        },
        {
            name: 'Carlsbad',
            point_radius: {
                radius: RADIUS,
                latitude: 33.1563,
                longitude: -117.3504,
            },
        },
    ],
    [PLACES.SAN_JOES_CA]: [
        {
            name: 'Stanford',
            point_radius: {
                radius: RADIUS,
                latitude: 37.422,
                longitude: -122.1707,
            },
        },
        {
            name: 'Downtown San Jose',
            point_radius: {
                radius: RADIUS,
                latitude: 37.3329,
                longitude: -121.8916,
            },
        },
        {
            name: 'Milpitas',
            point_radius: {
                radius: RADIUS,
                latitude: 37.3852,
                longitude: -121.9235,
            },
        },
    ],
    [PLACES.SEATTLE_WA]: [
        {
            name: 'Downtown Seattle',
            point_radius: {
                radius: RADIUS,
                latitude: 47.6112,
                longitude: -122.3358,
            },
        },
        {
            name: 'Pioneer Square',
            point_radius: {
                radius: RADIUS,
                latitude: 47.602,
                longitude: -122.3284,
            },
        },
        {
            name: 'South Lake Union',
            point_radius: {
                radius: RADIUS,
                latitude: 47.6262,
                longitude: -122.3431,
            },
        },
    ],
    [PLACES.SYDNEY_AU]: [
        {
            name: 'Haymarket',
            point_radius: {
                radius: RADIUS,
                latitude: -33.8688,
                longitude: 151.2093,
            },
        },
        {
            name: 'Randwick',
            point_radius: {
                radius: RADIUS,
                latitude: -33.9164,
                longitude: 151.2305,
            },
        },
        {
            name: 'Surry Hills',
            point_radius: {
                radius: RADIUS,
                latitude: -33.8844,
                longitude: 151.2014,
            },
        },
    ],
    [PLACES.TAMPA_FL]: [
        {
            name: 'Downtown Tampa',
            point_radius: {
                radius: RADIUS,
                latitude: 27.9494,
                longitude: -82.4567,
            },
        },
        {
            name: 'Downtown St. Petersburg',
            point_radius: {
                radius: RADIUS,
                latitude: 27.77,
                longitude: -82.6397,
            },
        },
        {
            name: 'Ybor City',
            point_radius: {
                radius: RADIUS,
                latitude: 27.9637,
                longitude: -82.4396,
            },
        },
    ],
    [PLACES.VANCOUVER_CA]: [
        {
            name: 'Whistler',
            point_radius: {
                radius: RADIUS,
                latitude: 49.705,
                longitude: -123.1522,
            },
        },
        {
            name: 'East Vancouver',
            point_radius: {
                radius: RADIUS,
                latitude: 49.2795,
                longitude: -123.0404,
            },
        },
        {
            name: 'Downtown Vancouver',
            point_radius: {
                radius: RADIUS,
                latitude: 49.2781,
                longitude: -123.1182,
            },
        },
    ],
    [PLACES.DUBLIN_IE]: [
        {
            name: 'South Dublin',
            point_radius: {
                radius: RADIUS,
                latitude: 53.3405,
                longitude: -6.262,
            },
        },
        {
            name: 'Ballsbridge',
            point_radius: {
                radius: RADIUS,
                latitude: 53.3394,
                longitude: -6.2716,
            },
        },
        {
            name: 'Phibsborough',
            point_radius: {
                radius: RADIUS,
                latitude: 53.3807,
                longitude: -6.2088,
            },
        },
    ],
};
